export function safeJsonParse<T>(input: string, fallback: T): T {
    try {
        return JSON.parse(input) as T;
    } catch {
        return fallback;
    }
}
